// axiosInstance.ts
import axios from "axios";
import { ServerBaseUrl } from "../routes";
import { createBrowserHistory } from "history";
import { getToken } from "./token";

export const history = createBrowserHistory();

const axiosInstance = axios.create({
  baseURL: ServerBaseUrl,
  headers: {
    "Content-Type": "application/json",
    authorization: `Bearer ${getToken()}`,
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      history.push("/login");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
